import React from "react";
import { Form } from "react-aria-components";
import { t as ttag } from "ttag";

import { reverse } from "@reactivated";

import { trackNewsletterSignup } from "../../../utils/analytics";
import { IconButton } from "../../Clickables";
import { TextField, useFormSubmit } from "../../Form";

import styles from "./Footer.module.scss";

export const NewsletterForm = ({
    intro,
    success,
}: {
    intro: React.ReactNode;
    success: React.ReactNode;
}) => {
    const [isSuccess, setIsSuccess] = React.useState(false);

    const { isSubmitting, nonFieldError, fieldErrors, handleSubmit } =
        useFormSubmit(
            (data) =>
                fetch(reverse("newsletter-subscribe"), {
                    method: "POST",
                    body: data,
                    headers: [["Accept", "application/json"]],
                }),
            () => {
                setIsSuccess(true);
                trackNewsletterSignup("footer");
            },
        );

    if (isSuccess) {
        return success;
    }

    return (
        <Form
            onSubmit={handleSubmit}
            validationErrors={fieldErrors}
            className={styles.newsletterForm}
        >
            {intro}
            {nonFieldError && (
                <p role="alert" className={styles.newsletterError}>
                    {nonFieldError}
                </p>
            )}
            <fieldset disabled={isSubmitting}>
                <TextField
                    name="email"
                    label={ttag`Email`}
                    type="email"
                    isRequired
                >
                    <IconButton
                        icon="arrow"
                        label={ttag`Submit`}
                        type="submit"
                    />
                </TextField>
            </fieldset>
        </Form>
    );
};
